import './telematicsVideo.css';
import video from '../../../assets/images/video-2.jpg'
const TelematicsVideo = ({handleShowVideoPlayer, video, index}) => {
    const showVideoPlayer = (index) => {
        handleShowVideoPlayer(true, index);
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    }

    return(
        <li className={`telematics-video ${video.isWatched ? '' : 'not-seen'}`}
            onClick={e => showVideoPlayer(index)}>
            <div className="icon width-block-100 margin-b-10">
                <img src={video.img} alt=""/>
            </div>
            <div className="font-14">
                <div className="flex gap-15 sf-medium margin-b-10">
                    <div className="rating-box">{video.tag}</div>
                    <div className="font-15"><span className={'margin-r-15'}>19:27</span>   15 Sep 2023</div>
                </div>
                <ul className="separator gap-30 sf-bold margin-b-10">
                    <li>KA 02  N 9023</li>
                    <li>Driver:  <span className={'blue-color'}>Babu K</span></li>
                </ul>
                <div className="grey-color sf-medium">Eicher/HMV    Chennai - Ahmedabad</div>
            </div>
        </li>
    )
}

export default TelematicsVideo;
